import { render, staticRenderFns } from "./PatientFormComponent.vue?vue&type=template&id=54ae9de1&scoped=true"
import script from "./PatientFormComponent.vue?vue&type=script&lang=ts"
export * from "./PatientFormComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae9de1",
  null
  
)

export default component.exports